import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const SubstanceGrpcContractProvider: Provider = {
  provide: MainApi.SubstanceGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.SubstanceGrpcContractClient, 'mainApi'),
};
